import request from '../../../axios';

const patchUserPromotedRequirement = async (guid: string) => {
  await request.patch(`/api/v2/wanted/user-promoted-requirement/${guid}`);
};

export default patchUserPromotedRequirement;
